import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '300px',
    backgroundColor: 'rgba(249, 249, 249, 0.8)',
    borderRadius: '8px',
  },
  spinner: {
    marginBottom: '16px',
  },
  text: {
    color: '#1D2155',
    fontWeight: 500,
    textAlign: 'center',
  },
}));

const LoadingChart = ({ message = "Loading chart data..." }) => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <CircularProgress
        className={classes.spinner}
        size={50}
        thickness={4}
        sx={{ color: '#008ed1' }}
      />
      <Typography variant="body1" className={classes.text}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingChart;